import { render } from "./WestpacBpay.vue?vue&type=template&id=04b9728a&scoped=true"
import script from "./WestpacBpay.vue?vue&type=script&lang=js"
export * from "./WestpacBpay.vue?vue&type=script&lang=js"

import "./WestpacBpay.vue?vue&type=style&index=0&id=04b9728a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b9728a"]])

export default __exports__